/** Unified recent-search source: server for logged-in users, local for guests.
 * Strictly scoped per account — never mixed after account switch. */
import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../auth/AuthContext";
import {
  deleteSearchHistory,
  fetchSearchHistory,
  recordSearchHistory,
} from "../api/searchHistoryApi";
import {
  entryId,
  listRecentSearches,
  removeRecentSearch,
  saveRecentSearch,
} from "../lib/recentSearches";

export default function useRecentSearches() {
  const { user } = useAuth();
  const scope = user?.ulid || "guest";
  const [items, setItems] = useState(() => listRecentSearches(scope));

  useEffect(() => {
    setItems(listRecentSearches(scope));
    if (user) {
      fetchSearchHistory()
        .then((d) => setItems((d?.items || []).slice(0, 4)))
        .catch(() => {});
    }
  }, [scope, user]);

  const record = useCallback((entry) => {
    // Local write keeps the UI instant; server write follows for accounts.
    setItems(saveRecentSearch(entry, scope));
    if (user) {
      recordSearchHistory({
        vertical: entry.vertical,
        label: entry.label,
        params: entry.params || {},
      })
        .then((d) => setItems((d?.items || []).slice(0, 4)))
        .catch(() => {});
    }
  }, [scope, user]);

  const remove = useCallback((id) => {
    setItems(removeRecentSearch(id, scope));
    if (user) deleteSearchHistory(id).catch(() => {});
  }, [scope, user]);

  return { items, record, remove, entryId };
}
